import { Inject, Injectable } from '@angular/core';
import { WindowToken } from '@app/util/window.token';
import { AppDataService } from '@app/services/appData.service';
import { AuthTokenService } from '@app/services/auth-token.service';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    private readonly baseUrl: string;

    constructor(
        @Inject(WindowToken) private window: Window,
        @Inject(AppDataService) private appDataService: AppDataService,
        @Inject(AuthTokenService) private authTokenService: AuthTokenService
    ) {
        this.baseUrl = this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL;
    }

    /**
     * Navigates the user to their intended destination after a successful login.
     * It checks for a saved location first, otherwise defaults to the properties page.
     */
    public navigateToAppAfterLogin(): void {
        const savedUrl = this.authTokenService.getAndClearSavedLocation();
        if (savedUrl) {
            this.window.location.href = savedUrl;
        } else {
            this.navigateToProperties();
        }
    }

    /**
     * Navigates to the main properties page for a registered user.
     */
    public navigateToProperties(): void {
        this.window.location.href = `${this.baseUrl}/registered/#/properties`;
    }

    /**
     * Navigates to the dedicated SSO linking page.
     */
    public navigateToSso(): void {
        this.window.location.href = `${this.baseUrl}/guest/#/sso`;
    }

    /**
     * Navigates to the main home/login page.
     */
    public navigateToHome(): void {
        this.window.location.href = this.baseUrl;
    }
}
